import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tooltip,
  Typography,
  Box,
  Divider,
  useMediaQuery,
} from "@mui/material";
// import {
//   Timeline,
//   TimelineItem,
//   TimelineSeparator,
//   TimelineDot,
//   TimelineConnector,
//   TimelineContent,
// } from "@mui/lab";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";

import { useTheme } from "@mui/material/styles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CreateIcon from "@mui/icons-material/Create";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import { black } from "@mui/material/colors";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import {getTransactionByBillNumber} from "../../../services/invoiceService";

const TransactionHistory = ({ billNumber,open, handleClose, billData }) => {
  //   const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [transactions, setTransactions] = useState([]);

  //   const handleOpen = () => setOpen(true);
  //   const handleClose = () => setOpen(false);
// console.log("billNumber",billNumber)
  const getTransactionsDetails = async () => {
    let response = await getTransactionByBillNumber(billNumber);
    // console.log("response", response?.data?.data);
    setTransactions(response?.data?.data);
  };

  useEffect(() => {
    if (billNumber) {
      getTransactionsDetails();
    }
  }, [billNumber]);

  return (
    <>
      {/* 👁️ Eye Icon */}
      {/* <Tooltip title="View Transaction Details">
        <IconButton
          onClick={() => {
            getTransactionsDetails();
            handleOpen();
          }}
          color="primary"
        >
          <VisibilityIcon />
        </IconButton>
      </Tooltip> */}

      {/* 🟢 Modal with Timeline */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth={isMobile ? "xs" : "sm"}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 600,
            fontSize: "1.2rem",
            color: theme.palette.primary.main,
            position: "relative",
          }}
        >
          Transaction History
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 2,
              top: -2,
              color: "black",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />

        <DialogContent
          sx={{
            maxHeight: "65vh",
            overflowY: "auto",
            px: { xs: 1, sm: 3 },
            py: 2,
          }}
        >
          {transactions?.length > 0 &&
          parseFloat(
            billData?.offlineBillDetails?.amountReceivedAgainstBill || 0
          ) > 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                minHeight: "220px",
                color: "text.secondary",
                bgcolor: "#f9f9f9",
                borderRadius: 2,
                p: 3,
              }}
            >
              <CheckCircleIcon
                sx={{
                  width: 60,
                  height: 60,
                  color: "success.main",
                  mb: 1,
                  animation: "pulse 1.5s infinite",
                  "@keyframes pulse": {
                    "0%": { transform: "scale(1)" },
                    "50%": { transform: "scale(1.05)" },
                    "100%": { transform: "scale(1)" },
                  },
                }}
              />

              <Typography
                variant="h4"
                sx={{
                  fontWeight: 500,
                  color: "success.main",
                  // textTransform: "uppercase",
                  letterSpacing: "0.8px",
                }}
              >
                Payment Successful (Offline)
              </Typography>

              <Typography variant="body2">
                <strong>Payment Mode:</strong>{" "}
                {billData?.branch?.paymentType === "FULL_PAYMENT"
                  ? "Full Payment"
                  : "Partial Payment"}
              </Typography>
              <Typography variant="body2">
                <strong>Payment Method:</strong>{" "}
                {billData?.offlineBillDetails?.paymentMethods}
              </Typography>
              {/* <Typography variant="body2" sx={{ mt: 0.5 }}>
                <strong>Amount:</strong> ₹
                {parseFloat(
                  billData?.offlineBillDetails?.amountReceivedAgainstBill || 0
                )?.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography> */}
              {/* Footer note */}
              <Box
                sx={{
                  mt: 2,
                  bgcolor: "#e0e0e0", // light grey background
                  px: 2,
                  py: 1,
                  borderRadius: 1,
                  width: "105%",
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontStyle: "italic", color: "text.primary" }}
                >
                  Bill handled offline. ₹
                  {parseFloat(
                    billData?.offlineBillDetails?.amountReceivedAgainstBill || 0
                  )?.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}{" "}
                  paid to Jobizo team. Entry recorded.
                </Typography>
              </Box>
            </Box>
          ) : !transactions || transactions.length === 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                minHeight: "220px",
                color: "text.secondary",
              }}
            >
              <ReceiptLongIcon
                sx={{ width: 100, height: 100, color: "grey.400", mb: 5 }}
              />
              <Typography variant="h6" fontWeight={600}>
                No Transactions Found
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={0.5}>
                Make a payment to view your transaction history.
              </Typography>
            </Box>
          ) : (
            <Timeline
              position="right"
              sx={{
                "& .MuiTimelineItem-root": {
                  minHeight: "auto",
                },
                "& .MuiTimelineItem-missingOppositeContent:before": {
                  flex: 0,
                  padding: 0,
                },
              }}
            >
              {transactions.map((txn, index) => (
                <TimelineItem key={index}>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        bgcolor:
                          txn.status === "SUCCESS"
                            ? theme.palette.success.main
                            : txn.status === "FAILED"
                            ? theme.palette.error.main
                            : txn.status === "CREATED"
                            ? "#FFA500"
                            : txn.status === "USER_DROPPED"
                            ? "#FFB300"
                            : theme.palette.grey[500],
                      }}
                    />
                    {index < transactions.length - 1 && <TimelineConnector />}
                  </TimelineSeparator>

                  <TimelineContent>
                    <Box
                      sx={{
                        bgcolor: "#f9f9f9",
                        p: 1.5,
                        borderRadius: 1.5,
                        mb: 2,
                      }}
                    >
                      {/* Status */}
                      <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        color={
                          txn.status === "SUCCESS"
                            ? "success.main"
                            : txn.status === "FAILED"
                            ? "error.main"
                            : txn.status === "CREATED"
                            ? "#FFA500"
                            : txn.status === "USER_DROPPED"
                            ? "#FFB300"
                            : "text.primary"
                        }
                        sx={{ display: "flex", alignItems: "center", mr: 1 }}
                      >
                        {txn.status === "SUCCESS" && (
                          <CheckCircleIcon
                            fontSize="small"
                            sx={{ mr: 0.5, mb: 0.3 }}
                          />
                        )}
                        {txn.status === "FAILED" && (
                          <CancelIcon
                            fontSize="small"
                            sx={{ mr: 0.5, mb: 0.3 }}
                          />
                        )}
                        {txn.status === "CREATED" && (
                          <PlayCircleOutlineIcon
                            fontSize="small"
                            sx={{ mr: 0.5, mb: 0.3 }}
                          />
                        )}
                        {txn.status === "USER_DROPPED" && (
                          <RemoveCircleOutlineIcon
                            fontSize="small"
                            sx={{ mr: 0.5, mb: 0.3 }}
                          />
                        )}
                        {txn.status === "CREATED"
                          ? "INITIATED"
                          : txn.status === "USER_DROPPED"
                          ? "USER DROPPED"
                          : txn.status}
                      </Typography>
                      {/* <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      color={
                        txn.status === "SUCCESS"
                          ? "success.main"
                          : txn.status === "FAILED"
                          ? "error.main"
                          : txn.status === "CREATED"
                          ? "#FFA500"
                          : txn.status === "DROPPED"
                          ? "#FFB300"
                          : "text.primary"
                      }
                    >
                      {txn.status}
                    </Typography> */}

                      {/* Timestamp */}
                      <Typography variant="body2" color="text.secondary">
                        {txn.status === "CREATED"
                          ? new Date(txn.paymentCreatedAt).toLocaleString()
                          : new Date(txn.payment_time).toLocaleString()}
                      </Typography>

                      {/* Payment Mode */}
                      {txn.paymentMode && (
                        <Typography
                          variant="body2"
                          sx={{
                            fontStyle: "italic",
                            color: "text.secondary",
                            mt: 0.5,
                          }}
                        >
                          Payment Mode:{" "}
                          {txn.paymentMode === "full_payment"
                            ? "Full Payment"
                            : "Partial Payment"}
                        </Typography>
                      )}
                    </Box>
                  </TimelineContent>
                </TimelineItem>
              ))}
            </Timeline>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TransactionHistory;
